import { __assign, __rest } from "tslib";
// DS3.1 - No label / no bottom padding version
import React, { useRef, useState } from 'react';
import c from 'classnames';
import isFunction from 'lodash/isFunction';
import InputFieldOutline from '../InputFieldOutline';
import BaseInput from '../BaseInput';
import s from './InputField.scss';
/**
 * One of our standard `<input />`s.
 *
 * Provides space for a prefix and postfix, and allows indication of success or error via `validationResult`.
 */
var InputField = React.forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, prefix = _a.prefix, postfix = _a.postfix, validationResult = _a.validationResult, className = _a.className, disabled = _a.disabled, onFocusProp = _a.onFocus, onBlurProp = _a.onBlur, rest = __rest(_a, ["type", "prefix", "postfix", "validationResult", "className", "disabled", "onFocus", "onBlur"]);
    var _c = useState(false), isFocused = _c[0], setIsFocused = _c[1];
    var onFocus = function (e) {
        setIsFocused(true);
        onFocusProp && onFocusProp(e);
    };
    var onBlur = function (e) {
        setIsFocused(false);
        onBlurProp && onBlurProp(e);
    };
    var localInputRef = useRef();
    return (React.createElement(InputFieldOutline, { className: c(s['root'], isFocused && s['focused'], disabled && s['disabled'], className), outlineStyle: disabled ? 'disabled' : validationResult, onClick: function () { return localInputRef.current && localInputRef.current.focus(); } },
        prefix && React.createElement("span", { className: s['prefix'] }, prefix),
        React.createElement(BaseInput, __assign({ type: type, className: s['input'], disabled: disabled, "aria-invalid": validationResult === 'error', ref: function (node) {
                if (isFunction(ref)) {
                    ref(node);
                }
                else if (ref) {
                    ref.current = node;
                }
                localInputRef.current = node;
            }, onFocus: onFocus, onBlur: onBlur }, rest)),
        postfix && React.createElement("span", { className: s['postfix'] }, postfix)));
});
InputField.displayName = 'InputField';
export default InputField;
//# sourceMappingURL=InputField.js.map